/* ------------------------------------------------------------------
   ヘッダーのカート個数を差し替える共通処理（v569）

   このテーマのヘッダー（sections/aug-header.liquid）は Dawn 標準の
   #cart-icon-bubble を使っていない。そのため Dawn 側の JavaScript が
   document.getElementById('cart-icon-bubble') を掴もうとして失敗し、
   カートページで数量を変えても合計欄が更新されない状態だった。

   代わりに sections/aug-cart-count.liquid（個数だけを返すセクション）を
   読み、ヘッダーのカートアイコンの中の .aug-hd__count を入れ替える。

   使い方（cart.js / cart-notification.js から）:
     window.augRenderCartCount(sectionHtml);
   ------------------------------------------------------------------ */
window.augRenderCartCount = function (sectionHtml) {
  try {
    if (!sectionHtml) return;

    var link = document.querySelector('a.aug-hd__icon[href$="/cart"]');
    if (!link) return;

    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var wrap = doc.querySelector('.shopify-section');
    var fresh = (wrap ? wrap.innerHTML : doc.body.innerHTML) || '';
    fresh = fresh.trim();

    var current = link.querySelector('.aug-hd__count');
    if (current) current.parentNode.removeChild(current);

    if (fresh) link.insertAdjacentHTML('beforeend', fresh);
  } catch (e) {
    /* 個数の表示が更新できなくても、カートの中身自体は正しく更新されている */
  }
};
